import { render, staticRenderFns } from "./complain-list.vue?vue&type=template&id=84dee5fa&scoped=true"
import script from "./complain-list.vue?vue&type=script&lang=js"
export * from "./complain-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dee5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84dee5fa')) {
      api.createRecord('84dee5fa', component.options)
    } else {
      api.reload('84dee5fa', component.options)
    }
    module.hot.accept("./complain-list.vue?vue&type=template&id=84dee5fa&scoped=true", function () {
      api.rerender('84dee5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/complain/complain-list.vue"
export default component.exports